export type Point = {
  x: number;
  y: number;
};

export type Context = {
  scale: number;
  isChalkLine: boolean;
  glassList: Pannel[];
  gapSize?: number;
};

export type Line = {
  start: Point;
  end: Point;
  angle?: number;
  parallelLine?: Line;
  numberOfDoors: number;
  pannels?: Pannel[];
};

export type Intersection = {
  line: Line;
  intersections: Line[];
};

export type Substraction = {
  line: Line;
  substractions: number;
};

export type Pannel = {
  length: number;
  price: Map<Province, number>;
  isRPannel?: boolean;
};

export enum Province {
  Quebec = "QUEBEC",
  Ontario = "ONTARIO",
}

export type FinalCost = {
  price: Map<Province, number>;
  total: number;
  length: number;
  isRPannel?: boolean;
  isDoor?: boolean;
};

export enum Material {
  WallAttachment = "Attache mur",
  Pannel180Attachemnt = "Attache 180",
  Pannel90Attachemnt = "Attache 90",
  AdjustableAttachement = "Attache ajustable",
  Spigots = "Spigot",
  HingeKit = "Penture (2)",
  DoorLatch = "Verrou aimanté",
  FloorLock = "Verrou de plancher",
}

export enum MaterialType {
  Silver = "Stainless",
  Black = "Stainless Noir",
}

export type Attachment = {
  material: Material;
  count: number;
  costBlack: Map<Province, number>;
  costSilver: Map<Province, number>;
};

export type QuotationFireStoreFields = {
  id: string;
  createdBy: string;
  address: string;
  chalkLine: boolean;
  name: string;
  includeAttachement: boolean;
  note: string;
  phone: string;
  email: string;
  province: string;
  selectedLength: string;
  material: string;
  scale: number;
  lines: string;
  date: {
    seconds: number;
    nanoseconds: number;
  };
  gapSize?: number;
};
